<app-pencil-button
  class="alert__priority-menu-trigger"
  buttonType="button"
  [matMenuTriggerFor]="priorityMenu"
  data-name="icon-dropdown-trigger"
>
  <app-pencil-icon
    *ngIf="currentOption as option"
    [name]="option.icon"
    [type]="IconTypes.svgIcon"
  ></app-pencil-icon>
  <span class="alert__priority-menu-trigger__label">{{ currentOption?.label }}</span>
  <app-pencil-icon name="keyboard_arrow_down" [type]="IconTypes.matIcon"></app-pencil-icon>
</app-pencil-button>

<mat-menu
  #priorityMenu="matMenu"
  class="pencil-mat-menu light-scheme preserve-icon-colors alert-priority-menu"
>
  <app-pencil-menu-item
    *ngFor="let option of priorityOptions"
    [label]="option.label"
    [icon]="option.icon"
    [iconConfig]="{ type: IconTypes.svgIcon, name: option.icon }"
    [selected]="option.id === priority"
    [renderCheckIcon]="option.id === priority"
    (clickEvent)="onPriorityChange(option.id)"
  ></app-pencil-menu-item>
</mat-menu>
